export default __webpack_public_path__ + "static/media/75t.88a442a4.jpg";